import { Grid } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import * as userService from "../../../models/services/userService";
import { Dialog } from "../../framework/Dialog/Dialog";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { FormPassword } from "source/components/framework/FormPassword";

export interface IUserEditChangePasswordDialogProp {
    classes?: string;
    userId: string;
    companyId: string;
    minPasswordLength: number;
    rowId: string;
    onOk: (rowId: string) => void;
    onCancel: () => void;
}

export interface IUserEditChangePasswordDialogState {
    newPassword: string;
    newPasswordConfirmation: string;
}

export class UserEditChangePasswordDialog extends React.Component<IUserEditChangePasswordDialogProp, IUserEditChangePasswordDialogState> {
    private orgStateHash: string = "";

    constructor(props: IUserEditChangePasswordDialogProp) {
        super(props);
        this.state = {
            newPassword: "",
            newPasswordConfirmation: "",
        };
        const saveData = this.getSaveDataFromState(props, this.state);
        this.orgStateHash = saveData.hash;
    }

    getSaveDataFromState = (props: IUserEditChangePasswordDialogProp, state: IUserEditChangePasswordDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("rowId", props.rowId);
        result.append("id", props.userId);
        result.append("companyId", props.companyId);
        result.append("newPassword", state.newPassword);
        result.append("newPasswordConfirmation", state.newPasswordConfirmation);
        return result;
    };
    
    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (!state.newPassword) {
                AppUtils.showErrorMessage(Translations.NewPasswordMustBeDefined);
                return resolve(false);
            }
            const errorMessage = Base.isValidPassword(state.newPassword, this.props.minPasswordLength);
            if (errorMessage) {
                AppUtils.showErrorMessage(errorMessage);
                return resolve(false);
            }
            if (!state.newPasswordConfirmation || state.newPassword !== state.newPasswordConfirmation) {
                AppUtils.showErrorMessage(Translations.PasswordConfirmationDoesNotMatchPassword);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    saveToDb = async () => {
        const props = this.props;
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors)) return;
        const saveData = this.getSaveDataFromState(props, state);
        //Call server
        const result = await AppUtils.callService(() => userService.userEditChangePassword(saveData.obj));
        if (!result) return;
        props.onOk(result.rowId);
    };

    handleSave = () => {
        this.saveToDb();
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveToDb();
        } else {
            props.onCancel();
        }
    };

    render() {
        const state = this.state;
        return (
            <Dialog
                id="userEditChangePasswordDialog"
                maxWidth="xs"
                title={Translations.ChangePassword}
                body={
                    <>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.NewPassword} required margin="0">
                                    <FormPassword
                                        tooltip={Translations.NewPassword}
                                        maxLength={50}
                                        value={state.newPassword}
                                        required={true}
                                        onChange={(newPassword) => this.setState({ newPassword })}
                                    />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.ConfirmPassword} required>
                                    <FormPassword
                                        tooltip={Translations.ConfirmPassword}
                                        maxLength={50}
                                        value={state.newPasswordConfirmation}
                                        required={true}
                                        onChange={(newPasswordConfirmation) => this.setState({ newPasswordConfirmation })}
                                    />
                                </FormField>
                            </Grid>
                        </GridRow>
                    </>
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.Save, variant: "contained", onClick: this.handleSave }
                ]}
                onClose={this.handleCancel}/>
        );
    }
}